@if (show) {
  <div class="toast-message shadow" [ngClass]="type">
    <p>{{ message }}</p>
  </div>
}
